"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSubscriptionTypes = useSubscriptionTypes;
var _checkoutUtils = require("@ori/checkout-utils");
var _environment = require("@ori/environment");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _react = require("react");
var _contexts = require("../contexts");
var _logger = require("../logger");
function useSubscriptionTypes(product) {
  const {
    customerId
  } = (0, _react.useContext)(_contexts.wizardContext);
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const params = {
    ...(product ? {
      product: product.toString()
    } : {})
  };
  const headers = {
    'x-tenant-context': tenant
  };
  const swrOptions = {
    ..._checkoutUtils.errorHandlingSwrOptions,
    onSuccess: () => {
      (0, _logger.logDebug)('useSubscriptionTypes() hook finished successfully');
    }
  };
  const {
    data,
    error,
    isValidating: isLoading
  } = (0, _globalApiClientReact.useGetCustomerSubscriptionTypes)(customerId, params, headers, {
    swr: swrOptions
  });
  return {
    data,
    error,
    isLoading
  };
}
